import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { processCitationsInText, preprocessMarkdown } from "./textProcessing";
import { customRenderers } from "./customRenderers";
import { type Evidence } from "@/types/evidences";

interface MarkdownRendererProps {
  content: string;
  evidences: Evidence[];
  processCitations: boolean;
}

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, evidences, processCitations }) => {
  const [processedContent, setProcessedContent] = useState<React.ReactNode[]>([]);

  useEffect(() => {
    let preprocessedContent = preprocessMarkdown(content);
    preprocessedContent = preprocessedContent.replace(/\n/g, "\n\n"); // Preserve line breaks for formatting.

    if (processCitations) {
      setProcessedContent(processCitationsInText(preprocessedContent, evidences));
    } else {
      setProcessedContent([preprocessedContent]);
    }
  }, [content, processCitations, evidences]);

  return (
    <div className="markdown-content relative space-y-4">
      {processedContent.map((part, index) =>
        typeof part === "string" ? (
          <ReactMarkdown key={index} components={customRenderers}>
            {part}
          </ReactMarkdown>
        ) : (
          part
        ),
      )}
    </div>
  );
};
